// eslint-disable-next-line no-unused-vars
import config from '@config';
import './vendor/accessible-slick.min.js'; import './vendor/bootstrap.js';
import '@styles/frontend';
import '@images/background--admissions-and-requirements.jpg';
import '@images/favicon.ico';
import '@images/icon--bank.svg';
import '@images/icon--department-store.svg';
import '@images/icon--food.svg';
import '@images/icon--gym.svg';
import '@images/icon--hospital.svg';
import '@images/icon--restaurant.svg';
import '@images/icon--transit-station.svg';
import '@images/illustration--arrow-keys.svg';
import '@images/logo--study-ontario-canada.svg';
import '@images/symbol--circled-minus.svg';
import '@images/symbol--circled-plus.svg';
import '@images/symbol--circled-plus--red.svg';
import '@images/symbol--circled-x.svg';
import '@images/symbol--menu.svg';
import '@images/symbol--menu--close.svg';
import '@images/symbol--open-modal-dialog.svg';
import '@images/symbol--play.svg';
import '@images/symbol--quotation-mark--double--left.svg';
import '@images/symbol--x.svg';
import './spritesvg';
import '@images/loading.svg';
import '@images/loading-white.svg';
// Favicon
import '@images/favicon/apple-touch-icon.png';
import '@images/favicon/favicon-32x32.png';
import '@images/favicon/favicon-16x16.png';
// Slideshow
import '@images/slideshow/welcome-1600.jpg';
import '@images/slideshow/welcome-1200.jpg';
import '@images/slideshow/welcome-620.jpg';
import '@images/slideshow/studying.jpg';
import '@images/slideshow/study-length.png';
import '@images/slideshow/students.jpg';
import '@images/slideshow/online-learning.jpg';
import '@images/slideshow/diverse-courses.jpg';

// Your code goes here ...
import Animations from '@scripts/frontend/Animations';
import Carousel from '@scripts/frontend/progressive-enhancements/Carousel';
import Disclosure from '@scripts/frontend/progressive-enhancements/Disclosure';
import Filters from '@scripts/frontend/Filters';
import Helpers from '@scripts/frontend/Helpers';
import Lightbox from '@scripts/frontend/progressive-enhancements/Lightbox';
import Map from '@scripts/frontend/progressive-enhancements/Map';
import Header from '@scripts/frontend/Header';
import ModalDialog from '@scripts/frontend/progressive-enhancements/ModalDialog';
import Notifications from '@scripts/frontend/Notifications';
import TabbedInterface from '@scripts/frontend/progressive-enhancements/TabbedInterface';
import Video from '@scripts/frontend/progressive-enhancements/Video';

// Initialize scripts
document.addEventListener('DOMContentLoaded', () => {
    const helpers = new Helpers();

    // Initialize the filters
    const notifications = new Notifications();
    notifications.init(helpers);
    
    /* Add Progressive Enhancements */
    
    // Disclosure - hide and show content with the click of a `<button>`
    const disclosure = new Disclosure();
    disclosure.init(helpers);
    
    // Gallery - convert a `<section>` with a list of thumbnail images into a list of thumbnail `<button>`s. Clicking a `<button>` opens a Modal Dialog containing a Carousel. The Carousel opens on the image/position that matches the thumbnail `<button>` that was clicked
    const modalDialog = new ModalDialog();
    modalDialog.init(helpers);

    const header = new Header();
    header.init(helpers, modalDialog);

    const carousel = new Carousel();
    carousel.init(helpers);

    // Tabbed Interface - convert a group (`<div>`) of `<section>`s into a Tabbed Interface
    const tabbedInterface = new TabbedInterface();
    tabbedInterface.init(helpers);

    const map = new Map();
    map.init(helpers);

    // Lightbox - convert a `<section>` with a list of thumbnail images into a list of thumbnail `<button>`s. Clicking a `<button>` opens a Modal Dialog containing a Carousel. The Carousel opens on the image/position that matches the thumbnail `<button>` that was clicked
    const lightbox = new Lightbox();
    lightbox.init(carousel, helpers, modalDialog);


    const video = new Video();
    video.init(helpers);

    // Animations
    const animations = new Animations();
    animations.init();

    // Initialize the filters
    const filters = new Filters();
    filters.init();
});